/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { ROUTE_ROOT, ROUTE_SIGN_IN, ROUTE_RULES } from '../routes/paths'
import { useAuth } from '../contexts/auth.context'

export function useRouteHandle() {
  const navigate = useNavigate()
  let location = useLocation()
  const { authenticated } = useAuth()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const code = params.get('code')
    const state = params.get('state')
    const isCognitoRedirect = code && state

    switch (location.pathname) {
      // handle un-authenticated routes
      case ROUTE_ROOT:
        if (authenticated) navigate(ROUTE_RULES)
        else navigate(ROUTE_RULES)
        break
      case ROUTE_SIGN_IN:
        if (authenticated) navigate(ROUTE_RULES)
        break

      // all other authenticated routes
      default:
        if (!authenticated && !isCognitoRedirect) navigate(ROUTE_SIGN_IN)
        break
    }
  }, [authenticated, location])
}
